import React from 'react';
import { NavLink } from 'react-router-dom';
import './SidebarNav.css';

const SidebarNav: React.FC = () => {
  return (
    <div className="sidebar-nav">
      <div className="nav-item home-nav-item">
        <NavLink to="/" end>Home</NavLink>
      </div>
      <div className="nav-item">
        <NavLink to="/byroso">byRoso</NavLink>
      </div>
      <div className="nav-item">
        <NavLink to="/fssc">FSSC</NavLink>
      </div>
      <div className="nav-item">
        <NavLink to="/events">Events</NavLink>
      </div>
    </div>
  );
};

export default SidebarNav; 